import { render, staticRenderFns } from "./titles.vue?vue&type=template&id=1791fd59&"
import script from "./titles.vue?vue&type=script&lang=js&"
export * from "./titles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports